import styles from './styles.module.scss';
import SubMenu from '../sub-menu';
import Icon from 'components/icon';
import { useState } from 'react';
import Menu from 'models/Menu';
import { updateCookieCurrentProduct } from 'utils/productCookies';

type MenuProps = {
  productNoun : string,
  menu : Menu
}

function MenuItem({ productNoun, menu } : MenuProps) : JSX.Element {
  const [open, toogleDropDown] = useState(false);

  const getIconClass = () : string => {
    const className = !menu.iconName ? styles['biobar-menu-without-icon'] : styles['biobar-menu-icon'];
    return ` ${className}`;
  };

  const onClick = () : void => {
    toogleDropDown(x => !x);

    if(!hasChild())
      updateCookieCurrentProduct(productNoun);
  };

  const hasChild = () : boolean => {
    if (menu.menu === undefined) return false;
    return menu.menu.length > 0;
  };

  return (
    <>
      <a
        href={ menu.url }
        className={ `${styles['biobar-menu-item']}${getIconClass()}` }
        onClick={onClick}>
        { menu.iconName && <Icon useOutlined={true} iconName={menu.iconName}/> }
        { menu.name }
        { hasChild() &&
          <Icon
            useOutlined={true}
            className={styles['biobar-dropdown-button']}
            iconName={`keyboard_arrow_${open ? 'up' : 'down' }`}/>
        }
      </a>
      { open &&
        hasChild() &&
        menu.menu.map((subMenu, i)=> <SubMenu
          productNoun={productNoun}
          breadcrumb={menu.name}
          menu={subMenu} key={i}/>)
      }
    </>
  );
}

export default MenuItem;